module.exports = __webpack_public_path__ + "images/unemployed.png";